import { colorPalette } from 'ui-blocks/ColorPalette';

export const characteristicsSectionStyles = {
	mainContainer: {
		display: 'flex',
		flexDirection: { xs: 'column-reverse ', mobileUi: 'row' },
		gap: { xs: '24px', xxl: '152px' },
		width: '100%',
	},
	videoContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: { xs: '8px', lg: '16px' },
		width: { xs: '100%', mobileUi: '75%', xxl: '65%' },
	},
	topVideoContainer: {
		display: 'flex',
		flexDirection: 'row',
		gap: { xs: '8px', lg: '16px' },
		width: '100%',
	},
	bottomVideoContainer: {
		display: 'flex',
		flexDirection: 'row',
		gap: { xs: '8px', lg: '16px' },
		width: '100%',
	},
	baseVideo: {
		border: `1px solid ${colorPalette.dark3}`,
		objectFit: 'cover',
		width: '100%',
		height: '100%',
	},
};
